




































































import { DataTableAction, DetailsField, DetailsFieldType } from '@/utils/types'
import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'
@Component
export default class FullscreenDetails extends Vue {
  @Prop(Array) readonly actions!: DataTableAction[]
  @Prop(Array) readonly fields!: DetailsField[]
  @Prop(Object) readonly model!: object
  @Prop(String) readonly title!: string
  @Prop(Number) readonly columnsMd!: number
  @PropSync('visible') isVisible!: boolean

  detailsFieldType = DetailsFieldType
  modelClone: object = {}
  isLoading = false

  getFieldValue (field: string) {
    return _.get(this.model, field)
  }

  handleAction (action: DataTableAction) {
    action.handler(this.model)
    this.isVisible = false
  }

  async handleFieldAction (field: DetailsField) {
    if (!field.action) {
      return
    }
    this.isLoading = true
    await field.action(this.model)
    this.isLoading = false
  }
}
